export enum RenewalStatus {
  TBD = 'TBD',
  Renewed = 'Renewed',
  InProgress = 'InProgress',
  Lost = 'Lost',
}
